import { NavMenuItem } from '../NavMenuItem/NavMenuItem'
import { Search } from 'blaze-ui/icons'
import { SearchModal } from 'screens/blaze/Search/SearchModal/SearchModal'
import { useModals } from 'almanac-ui/Modal'

const NavMenuSearchItem = () => {
  const { openModal } = useModals()

  return (
    <NavMenuItem size="md" icon={Search} activeIcon={Search} onPress={() => openModal(SearchModal)} label="Search" />
  )
}

export { NavMenuSearchItem }
